export default __webpack_public_path__ + "static/media/sgkit.9cf9af5e.png";